import css from 'styled-jsx/css';
import { colors, typography } from '../../../config/styles';
import _ from '../../../utils/LodashImports';

const style = (theme) => {
  const secondaryColor = _.get(theme, 'secondary_color', null) || colors.secondary_color;
  return css`
    .create-list-button {
      display: block;
      @mixin fallback {
        display: inherit;
      }
    }
    .button-text {
      text-decoration: underline;
      color: ${colors.gray.shade15};
      font-weight: 400;
      font-size: 13px;
      line-height: 16px;
      margin-left: 12px;
      margin-bottom: 23px;
    }
    .csicon-add {
      color: ${secondaryColor};
      font-size: ${typography.sm};
      font-weight: bolder;
    }
    .create-list-button.to_com {
      .button-text {
        color: ${colors.green.shade27};
      }
      .csicon-add {
        color: ${colors.green.shade27};
      }
    }
  `;
};
export default style;
